import { InputHTMLAttributes } from 'react';
import FlexCol from './FlexCol';
import FlexRow from './FlexRow';

export interface FlexProps extends InputHTMLAttributes<HTMLDivElement> {}

export default Object.assign(
  {},
  {
    Row: FlexRow,
    Col: FlexCol,
  },
);
